module.exports = __webpack_public_path__ + "media/images/common/logo_bg_03-a789d9c9c28381507339b8b5839830fd.png";